<div class="p-6 flex flex-col gap-4">
  <app-table
    [config]="sourceTable"
    [data]="sourceData"
    [(selectedElements)]="selectedElements"
  ></app-table>

  @if (selectedFormula; as formula) {
    <app-table
      [config]="parameterTable"
      [data]="formula.parameters ?? []"
    ></app-table>
  }
</div>
